export function InformativeItem({ type, data }) {
  if (!data) {
    return <p>No {type} found</p>;
  }

  return (
    <div
      className="admin-text-editor overflow-hidden"
      dangerouslySetInnerHTML={{ __html: data }}
    />
  );
}
